import axios from 'axios';

export const getVesselSize = type => {
  return axios
    .get(`vessel-charter/vendor-vessel/${type}`)
    .then(res => res)
    .catch(err => {
      throw err.response;
    });
};

export const getCommodities = () => {
  return axios
    .get('vessel-charter/commodities')
    .then(res => res)
    .catch(err => {
      throw err.response;
    });
};



// WEBPACK FOOTER //
// ./src/api/vessel-charter.api.js